import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SubscriptionSuspendReason } from '../../enums/subscription-suspend-reason';
import { SubscriptionSuspendReasonPipe } from '../../pipes/subscription-suspend-reason.pipe';

@Component({
  selector: 'app-subscription-suspend-reason',
  imports: [CommonModule, SubscriptionSuspendReasonPipe],
  templateUrl: './subscription-suspend-reason.component.html',
  styleUrl: './subscription-suspend-reason.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SubscriptionSuspendReasonComponent {
  public readonly reason = input.required<SubscriptionSuspendReason>();
}
